module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/boxoffice-module/common/transaction-refund-reason-box/transaction-refund-reason-box.component.scss
// module id = ./src/app/modules/boxoffice-module/common/transaction-refund-reason-box/transaction-refund-reason-box.component.scss
// module chunks = 9